import injectSheet from 'react-jss';
import theme, { buttonReset, em } from '../../styles/theme';

const fontSizes = {
  sm: 13,
  md: 16,
  lg: 20,
};

export default injectSheet({
  root: {
    position: 'relative',
    '& > *': {
      position: 'relative',
    },
  },
  form: {
    width: '100%',
    maxWidth: 600,
    alignItems: 'baseline',
    display: 'flex',
    flexDirection: 'column',
    fontSize: fontSizes.sm,
    [theme.breakpoints.up('md')]: {
      margin: [0, '-0.5rem'],
      flexDirection: 'row',
      fontSize: fontSizes.md,
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: fontSizes.lg,
    },
    '& input, & select, & button': {
      marginBottom: 0,
      padding: 0,
    },
    '& > *': {
      margin: [0, 0, '1rem'],
      [theme.breakpoints.up('md')]: {
        margin: [0, '0.5rem'],
      },
    },
    '& select': {
      paddingRight: '2.5rem',
      width: 'auto',
      appearance: 'none',
      cursor: 'pointer',
      background: 'none',
    },
    '& select option': {
      color: theme.colors.brandBlack,
      fontSize: em(fontSizes, 16, 'sm'),
    },
    '& button': {
      flexGrow: 0,
      flexShrink: 0,
    },
    '& input, & input:focus, & select': {
      color: 'inherit',
      backgroundColor: theme.colors.transparent,
      border: 'none',
      borderBottom: '3px solid currentColor',
      fontSize: em(fontSizes, 16, 'sm'),
      fontFamily: theme.fonts.body,
      fontWeight: theme.fonts.bodyWeight,
      height: 28,
      borderRadius: 0,
      [theme.breakpoints.up('md')]: {
        height: 28,
        fontSize: em(fontSizes, 16, 'md'),
      },
      [theme.breakpoints.up('lg')]: {
        height: 28,
        fontSize: em(fontSizes, 16, 'lg'),
      },
    },
    '& input': {
      maxWidth: 289,
    },
    '& input::placeholder, & input:disabled': {
      color: 'inherit',
      opacity: 0.5,
    },
    '& input:disabled': {
      backgroundColor: theme.colors.transparent,
    },
  },
  selectContainer: {
    flexGrow: 0,
    position: 'relative',
    '&::after': {
      pointerEvents: 'none',
      content: '""',
      position: 'absolute',
      right: '0.5rem',
      top: 'calc(50% - 0.2em)',
      borderColor: theme.colors.secondary,
      borderWidth: '0 1px 1px 0',
      borderStyle: 'solid',
      width: '0.5rem',
      height: '0.5rem',
      transform: 'translate(0, -50%) rotate(45deg)',
    },
  },
  message: {
    marginTop: 6,
    fontSize: '0.75rem',
    lineHeight: '16px',
    letterSpacing: 0.4,
    display: 'block',
    '& p': {
      fontSize: '0.75rem',
      fontFamily: theme.fonts.body,
      margin: 0,
    },
    '&.errorText': {
      color: theme.colors.brandError,
    },
  },
  title: {
    color: 'inherit',
    fontFamily: theme.fonts.bold,
    fontWeight: theme.fonts.boldWeight,
    letterSpacing: 0.3,
    lineHeight: 1.56,
    fontSize: em(fontSizes, 18, 'sm'),
    margin: [0, 0, '1rem'],
    [theme.breakpoints.up('md')]: {
      fontSize: em(fontSizes, 18, 'md'),
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: em(fontSizes, 18, 'lg'),
    },
  },
  inputContainer: {
    flexGrow: 1,
    width: '100%',
    maxWidth: 289,
    [theme.breakpoints.up('md')]: {
      maxWidth: '100%',
      minWidth: 'auto',
    },
  },
  button: {
    ...buttonReset({
      color: 'inherit',
      transition: 'background-color 0.2s ease-out',
      border: '1px solid',
      borderRadius: 4,
      borderColor: 'currentColor',
      '&:hover,&:focus': {
        color: 'inherit',
        background: 'currentColor',
        borderColor: 'currentColor',
      },
    }),
  },
  formContainer: {
    display: 'none',
    '&.formVisible': {
      display: 'block',
    },
    [theme.breakpoints.up('md')]: {
      transition: 'none',
      display: 'block',
    },
  },
  joinNowContainer: {
    display: 'block',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
    '&.formVisible': {
      display: 'none',
    },
  },
});
